import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleable"]

  toggleDisplay(){
    this.toggleableTarget.classList.toggle("d-none")
  }
}
